import React from 'react';
import { Link } from 'react-router-dom';
import type { Trophy } from '../types';
import './TrophyCard.css';

interface TrophyCardProps {
  trophy: Trophy;
  isUnlocked: boolean;
  unlockedAt?: string;
  isAI?: boolean;
  imageUrl?: string;
  onClick?: () => void;
}

export const TrophyCard: React.FC<TrophyCardProps> = ({
  trophy,
  isUnlocked,
  unlockedAt,
  isAI = false,
  imageUrl,
  onClick,
}) => {
  const cardClass = `trophy-card ${isUnlocked ? 'unlocked' : 'locked'} ${isAI ? 'ai-trophy' : ''}`;
  
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ro-RO', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };

  const getCategoryLabel = (category: Trophy['categorie']) => {
    const labels = {
      web: 'Web',
      game: 'Joc',
      ai: 'AI',
      bonus: 'Bonus',
    };
    return labels[category];
  };

  const content = (
    <>
      <div className="trophy-card-icon">
        {isUnlocked ? (
          imageUrl ? (
            <img src={imageUrl} alt={trophy.nume} />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: trophy.icon }} />
          )
        ) : (
          <div className="trophy-locked-icon">
            <span className="lock-icon">🔒</span>
          </div>
        )}
      </div>
      <div className="trophy-card-content">
        <span className={`trophy-category trophy-category-${trophy.categorie}`}>
          {getCategoryLabel(trophy.categorie)}
        </span>
        <h3 className="trophy-name">{isUnlocked ? trophy.nume : '???'}</h3>
        {isUnlocked ? (
          <>
            <p className="trophy-description">{trophy.descriere}</p>
            {unlockedAt && (
              <span className="trophy-date">
                Deblocat: {formatDate(unlockedAt)}
              </span>
            )}
          </>
        ) : (
          <p className="trophy-hint">Continuă să înveți pentru a debloca!</p>
        )}
      </div>
    </>
  );

  if (onClick) {
    return (
      <button className={cardClass} onClick={onClick} type="button">
        {content}
      </button>
    );
  }

  if (isUnlocked) {
    return (
      <Link to={`/trofeu/${trophy.id}`} className={cardClass}>
        {content}
      </Link>
    );
  }

  return <div className={cardClass}>{content}</div>;
};
